import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isMobile } from 'react-device-detect';
import { ContactUsButton } from '../components/contactUsButton';
import { isConfigFlagEnabled } from '../config';
export const ContactUsDrawerButtonContainer = ({ closeDrawer }) => {
    if (isMobile && !isConfigFlagEnabled('contactUsModal')) {
        /**
         * On mobile, if the contact us modal is disabled:
         * - We assume we are running in PWA mode, so the user can't close a browser tab that was opened to show
         *   the contact us page because browser controls are not available.
         * - We need to load the Contact Us page in its own page because of how Formspree forms work (by submitting
         *   to a third-party page vs letting us handle the flow ourselves). Therefore we can't put it in a modal
         *   or some context that wouldn't impact an active game session.
         * Therefore, we won't provide the Contact Us button on mobile if already logged in and we are using the
         * Contact Us sub-page.
         */
        return null;
    }
    return (_jsx(ContactUsButton, { target: 'modal', isLoggedIn: true, variant: 'outlined', fullWidth: true, closeDrawer: closeDrawer }));
};
